import { ReactNode, HTMLAttributes } from 'react'

interface RootProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
  className?: string
}

export const Root = ({ children, className = '', ...rest }: RootProps) => (
  <div
    id="level-play-wrapper"
    className={`size-screen-safe flex-shrink-1 flex-grow-1 border-gray-300 shadow animate__animated animate__fadeIn bg-[url(/bgs/level-play.jpg)] bg-contain relative p-4 flex flex-col items-center justify-center gap-3 ${className}`}
    style={{
      transition: 'all 0.2s ease-in-out'
    }}
    {...rest}
  >
    <div className="absolute top-0 left-0 w-full h-full bg-dark/60"></div>
    {children}
  </div>
)
